export const APPROVAL_STRATEGY_LOAD = 'APPROVAL_STRATEGY_LOAD';
export const APPROVAL_STRATEGY_LOAD_SUCCESS = 'APPROVAL_STRATEGY_LOAD_SUCCESS';
export const APPROVAL_STRATEGY_LOAD_ERROR = 'APPROVAL_STRATEGY_LOAD_ERROR';
export const APPROVAL_STRATEGIES_LOAD = 'APPROVAL_STRATEGIES_LOAD';
export const APPROVAL_STRATEGIES_LOAD_SUCCESS = 'APPROVAL_STRATEGIES_LOAD_SUCCESS';
export const APPROVAL_STRATEGIES_LOAD_ERROR = 'APPROVAL_STRATEGIES_LOAD_ERROR';
export const APPROVAL_STRATEGY_ADD = 'APPROVAL_STRATEGY_ADD';
export const APPROVAL_STRATEGY_ADD_SUCCESS = 'APPROVAL_STRATEGY_ADD_SUCCESS';
export const APPROVAL_STRATEGY_ADD_ERROR = 'APPROVAL_STRATEGY_ADD_ERROR';
export const APPROVAL_STRATEGY_UPDATE = 'APPROVAL_STRATEGY_UPDATE';
export const APPROVAL_STRATEGY_UPDATE_SUCCESS = 'APPROVAL_STRATEGY_UPDATE_SUCCESS';
export const APPROVAL_STRATEGY_UPDATE_ERROR = 'APPROVAL_STRATEGY_UPDATE_ERROR';
export const APPROVAL_STRATEGY_DELETE = 'APPROVAL_STRATEGY_DELETE';
export const APPROVAL_STRATEGY_DELETE_SUCCESS = 'APPROVAL_STRATEGY_DELETE_SUCCESS';
export const APPROVAL_STRATEGY_DELETE_ERROR = 'APPROVAL_STRATEGY_DELETE_ERROR';
